import { fill } from '@sentry/core';
/**
 * The same as `import { fill } from '@sentry/core';` but with explicit types.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fillTyped(source, name, replacement) {
    fill(source, name, replacement);
}
